module.exports = __webpack_public_path__ + "static/media/han_per_work.b628802a.png";